import React, { useState } from 'react';
import '../styles/Dealership.css';

const Dealership = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        company: '',
        location: '',
        experience: '',
        message: ''
    });

    const handleInputChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log('Form submitted:', formData);
        alert('Thank you for your interest! We will contact you soon.');
    };

    const benefits = [
        {
            icon: '💰',
            title: 'Lucrative Margins',
            description: 'Competitive profit margins and attractive pricing structure'
        },
        {
            icon: '🛡️',
            title: 'Quality Products',
            description: 'Access to premium MapLube products with proven performance'
        },
        {
            icon: '📈',
            title: 'Business Growth',
            description: 'Support and training to help grow your business'
        },
        {
            icon: '🎯',
            title: 'Marketing Support',
            description: 'Marketing materials, banners, and promotional support'
        },
        {
            icon: '🔧',
            title: 'Technical Support',
            description: 'Expert technical guidance and product training'
        },
        {
            icon: '🚚',
            title: 'Logistics Support',
            description: 'Efficient supply chain and delivery network'
        }
    ];

    const requirements = [
        {
            title: 'Business Experience',
            description: 'Minimum 2 years of experience in automotive or lubricant business'
        },
        {
            title: 'Financial Stability',
            description: 'Adequate financial resources for inventory and operations'
        },
        {
            title: 'Location',
            description: 'Strategic location with good market potential'
        },
        {
            title: 'Infrastructure',
            description: 'Proper storage facilities and display area'
        },
        {
            title: 'Team',
            description: 'Dedicated team for sales and customer service'
        },
        {
            title: 'Commitment',
            description: 'Commitment to MapLube brand values and quality standards'
        }
    ];

    const process = [
        {
            step: '01',
            title: 'Application',
            description: 'Submit your dealership application with required documents'
        },
        {
            step: '02',
            title: 'Evaluation',
            description: 'Our team evaluates your application and business potential'
        },
        {
            step: '03',
            title: 'Meeting',
            description: 'Personal meeting to discuss partnership details'
        },
        {
            step: '04',
            title: 'Agreement',
            description: 'Sign dealership agreement and complete formalities'
        },
        {
            step: '05',
            title: 'Training',
            description: 'Receive product and business training'
        },
        {
            step: '06',
            title: 'Launch',
            description: 'Start your MapLube dealership business'
        }
    ];

    return (
        <div className="dealership">
            {/* Hero Section */}
            <section className="dealership-hero">
                <div className="container">
                    <div className="dealership-hero-content">
                        <h1>Become a MapLube Dealer</h1>
                        <p>Join our network of successful dealers and grow your business with India's trusted lubricant brand</p>
                    </div>
                </div>
            </section>

            {/* Benefits Section */}
            <section className="benefits">
                <div className="container">
                    <h2>Why Partner with MapLube?</h2>
                    <div className="benefits-grid">
                        {benefits.map((benefit, index) => (
                            <div key={index} className="benefit-card">
                                <div className="benefit-icon">{benefit.icon}</div>
                                <h3>{benefit.title}</h3>
                                <p>{benefit.description}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Requirements Section */}
            <section className="requirements">
                <div className="container">
                    <h2>Dealership Requirements</h2>
                    <div className="requirements-grid">
                        {requirements.map((requirement, index) => (
                            <div key={index} className="requirement-card">
                                <h3>{requirement.title}</h3>
                                <p>{requirement.description}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Process Section */}
            <section className="process">
                <div className="container">
                    <h2>Application Process</h2>
                    <div className="process-timeline">
                        {process.map((step, index) => (
                            <div key={index} className="process-step">
                                <div className="step-number">{step.step}</div>
                                <div className="step-content">
                                    <h3>{step.title}</h3>
                                    <p>{step.description}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Application Form */}
            <section className="application-form">
                <div className="container">
                    <div className="form-content">
                        <div className="form-text">
                            <h2>Apply for Dealership</h2>
                            <p>Ready to join the MapLube family? Fill out the application form below and our team will contact you within 48 hours.</p>
                        </div>
                        <div className="form-container">
                            <form onSubmit={handleSubmit}>
                                <div className="form-group">
                                    <label htmlFor="name">Full Name *</label>
                                    <input
                                        type="text"
                                        id="name"
                                        name="name"
                                        value={formData.name}
                                        onChange={handleInputChange}
                                        required
                                    />
                                </div>
                                <div className="form-group">
                                    <label htmlFor="email">Email Address *</label>
                                    <input
                                        type="email"
                                        id="email"
                                        name="email"
                                        value={formData.email}
                                        onChange={handleInputChange}
                                        required
                                    />
                                </div>
                                <div className="form-group">
                                    <label htmlFor="phone">Phone Number *</label>
                                    <input
                                        type="tel"
                                        id="phone"
                                        name="phone"
                                        value={formData.phone}
                                        onChange={handleInputChange}
                                        required
                                    />
                                </div>
                                <div className="form-group">
                                    <label htmlFor="company">Company Name</label>
                                    <input
                                        type="text"
                                        id="company"
                                        name="company"
                                        value={formData.company}
                                        onChange={handleInputChange}
                                    />
                                </div>
                                <div className="form-group">
                                    <label htmlFor="location">Location *</label>
                                    <input
                                        type="text"
                                        id="location"
                                        name="location"
                                        value={formData.location}
                                        onChange={handleInputChange}
                                        required
                                    />
                                </div>
                                <div className="form-group">
                                    <label htmlFor="experience">Business Experience</label>
                                    <select
                                        id="experience"
                                        name="experience"
                                        value={formData.experience}
                                        onChange={handleInputChange}
                                    >
                                        <option value="">Select Experience</option>
                                        <option value="0-2">0-2 years</option>
                                        <option value="2-5">2-5 years</option>
                                        <option value="5-10">5-10 years</option>
                                        <option value="10+">10+ years</option>
                                    </select>
                                </div>
                                <div className="form-group">
                                    <label htmlFor="message">Additional Information</label>
                                    <textarea
                                        id="message"
                                        name="message"
                                        value={formData.message}
                                        onChange={handleInputChange}
                                        rows="4"
                                        placeholder="Tell us about your business and why you want to partner with MapLube..."
                                    ></textarea>
                                </div>
                                <button type="submit" className="btn btn-primary">Submit Application</button>
                            </form>
                        </div>
                    </div>
                </div>
            </section>

            {/* Contact Section */}
            <section className="dealership-contact">
                <div className="container">
                    <div className="contact-content">
                        <h2>Have Questions?</h2>
                        <p>Our dealership team is here to help you with any questions about becoming a MapLube dealer.</p>
                        <div className="contact-info">
                            <div className="contact-item">
                                <div className="contact-icon">📞</div>
                                <div>
                                    <h4>Call Us</h4>
                                    <p>+91 9540 071804</p>
                                </div>
                            </div>
                            <div className="contact-item">
                                <div className="contact-icon">✉️</div>
                                <div>
                                    <h4>Email Us</h4>
                                    <p>contact@maplube.in</p>
                                </div>
                            </div>
                            <div className="contact-item">
                                <div className="contact-icon">🕒</div>
                                <div>
                                    <h4>Business Hours</h4>
                                    <p>Mon-Fri: 9:00 AM - 6:00 PM</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Dealership; 